import { ModulosFornecedorInicial, ModulosFornecedorModel } from "../models/modulosFornecedorModel"
import { ModulosFornecedorActionModel, ModulosFornecedorActionsTypes } from "./modulosFornecedorActions"

export function modulosFornecedorReducer(
    state: ModulosFornecedorModel,
    action: ModulosFornecedorActionModel
): ModulosFornecedorModel {
    switch (action.type) {
        case ModulosFornecedorActionsTypes.CARREGAR:
            return action.payload

        default:
            return state
    }
}

export { ModulosFornecedorInicial }
